<script>
  import Text from '@components/general/text.svelte'
  import Image from '@components/general/image.svelte'
  import { Link } from '@inertiajs/svelte'
  import { cn } from '@lib/utils'

  let { contributor, heading, title, subtitle, size = "md", link = true, class: className } = $props()

  let href = $derived(link && contributor?.id ? `/contributors/${contributor.id}` : null)

  let containerClasses = {
    xs: 'gap-1 py-1',
    sm: 'gap-2 py-2',
    md: 'gap-3 py-3',
    lg: 'gap-4 py-4',
  }

  let contentClasses = {
    xs: 'gap-2',
    sm: 'gap-2',
    md: 'gap-2',
    lg: 'gap-3',
  }

  let imageClasses = {
    xs: 'w-6 h-6 text-xs',
    sm: 'w-7 h-7 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-sm',
  }

  let titleClasses = {
    xs: 'gap-0.5',
    sm: 'gap-1',
    md: 'gap-2',
    lg: 'gap-3',
  }
</script>

<section class={cn('flex flex-col gap-3 pb-5 border-b border-gray-200/80', containerClasses[size], className)}>

  <!-- The section title -->
  {#if heading}
    <Text variant="section_title" text={heading} as="h5" />
  {/if}
  
  <!-- The contributor image and name -->
  {#snippet content()}
    <div class={cn('flex items-center gap-2', contentClasses[size])}>
      
      <!-- The contributor image or fallback text -->
      <Image src={contributor?.image} alt={contributor?.name} text={contributor?.name?.charAt(0)} width={40} height={40} class={cn('object-center rounded-full border border-gray-200/70 bg-gray-100 text-gray-400', imageClasses[size])} />
      
      <!-- The contributor name and role -->
      <div class={cn('flex flex-col items-start', titleClasses[size])}>
        {#if title}
          {@render title()}
        {:else}
          <span class="text-gray-700 font-medium text-sm leading-none">{contributor.name}</span>
        {/if}
        {#if subtitle}
          {@render subtitle()}
        {:else}
          <span class="text-gray-500 text-sm leading-none">{contributor.role}</span>
        {/if}
      </div>

    </div>
  {/snippet}

  {#if href}
    <Link {href} class="hover:opacity-80 transition-opacity">
      {@render content()}
    </Link>
  {:else}
    {@render content()}
  {/if}
</section>
